// Redux Pricinglists module
// see https://github.com/erikras/ducks-modular-redux

import { change } from 'redux-form';
import { Pricinglists, Utils } from '../../services/';
import { make_temporary_pricing_id } from '../../services/entityIdFromName';
import { merge_pricings_for_form_sync } from '../../services/syncFormPricings';
import * as _ from 'es-toolkit';

const PRICINGLIST_FORM = 'pricinglistForm';

const sync_pricinglist_form_pricings = (dispatch, getState, renamed) => {
    const reducer_pricings = getState().pricinglists?.pricinglist?.pricings || {};
    const form_pricings = getState().form?.[PRICINGLIST_FORM]?.values?.pricings || {};
    dispatch(change(
        PRICINGLIST_FORM,
        'pricings',
        merge_pricings_for_form_sync(form_pricings, reducer_pricings, renamed)
    ));
};

const RESET_PRICINGLIST                  = 'kronos/pricinglists/RESET_PRICINGLIST';
const LOADING_PRICINGLISTS               = 'kronos/pricinglists/LOADING_PRICINGLISTS';
const LOADING_PRICINGLISTS_SUCCESS       = 'kronos/pricinglists/LOADING_PRICINGLISTS_SUCCESS';
const LOADING_PRICINGLISTS_FAILURE       = 'kronos/pricinglists/LOADING_PRICINGLISTS_FAILURE';
const LOADING_PRICINGLIST                = 'kronos/pricinglists/LOADING_PRICINGLIST';
const LOADING_PRICINGLIST_SUCCESS        = 'kronos/pricinglists/LOADING_PRICINGLIST_SUCCESS';
const LOADING_PRICINGLIST_FAILURE        = 'kronos/pricinglists/LOADING_PRICINGLIST_FAILURE';
const UPDATING_PRICINGLIST               = 'kronos/pricinglists/UPDATING_PRICINGLIST';
const UPDATING_PRICINGLIST_SUCCESS       = 'kronos/pricinglists/UPDATING_PRICINGLIST_SUCCESS';
const UPDATING_PRICINGLIST_FAILURE       = 'kronos/pricinglists/UPDATING_PRICINGLIST_FAILURE';
const START_CREATING_PRICINGLIST         = 'kronos/pricinglists/START_CREATING_PRICINGLIST';
const CREATING_PRICINGLIST               = 'kronos/pricinglists/CREATING_PRICINGLIST';
const CREATING_PRICINGLIST_SUCCESS       = 'kronos/pricinglists/CREATING_PRICINGLIST_SUCCESS';
const CREATING_PRICINGLIST_FAILURE       = 'kronos/pricinglists/CREATING_PRICINGLIST_FAILURE';
const DELETING_PRICINGLIST               = 'kronos/pricinglists/DELETING_PRICINGLIST';
const DELETING_PRICINGLIST_SUCCESS       = 'kronos/pricinglists/DELETING_PRICINGLIST_SUCCESS';
const DELETING_PRICINGLIST_FAILURE       = 'kronos/pricinglists/DELETING_PRICINGLIST_FAILURE';
const ADDING_PRICING                     = 'kronos/pricinglists/ADDING_PRICING';
const DUPLICATING_PRICING                = 'kronos/pricinglists/DUPLICATING_PRICING';
const REMOVING_PRICING                   = 'kronos/pricinglists/REMOVING_PRICING';
const DUPLICATING_PRICINGLIST            = 'kronos/pricinglists/DUPLICATING_PRICINGLIST';
const DUPLICATING_PRICINGLIST_SUCCESS    = 'kronos/pricinglists/DUPLICATING_PRICINGLIST_SUCCESS';
const DUPLICATING_PRICINGLIST_FAILURE    = 'kronos/pricinglists/DUPLICATING_PRICINGLIST_FAILURE';
const UPDATING_PRICINGLIST_ORDER         = 'kronos/pricinglists/UPDATING_PRICINGLIST_ORDER';
const UPDATING_PRICINGS_KEYS             = 'kronos/pricinglists/UPDATING_PRICINGS_KEYS';

const initialState = {
    isLoading: false,
    hasLoadingError: false,
    loadingErrorMessage: '',
    pricinglistSuccessfullyCreated: false,
    pricinglists: [],
    pricinglist: {},
    duplicatedPricinglist: {}
}

const initialPricing = (names, currency, vat, eshopWeight, idiv) => {
    const pricing = {
        name: names,
        // Empty strings keep Field paths bound without prefilling "0".
        price: { [currency]: '' },
        value: { [currency]: '' },
        value_per_screening: { [currency]: '' },
        wallet_amount: { [currency]: '' },
        variable_price: false,
        value_like_price: true,
        VAT: vat || 0,
        posters: [],
        rules: {
            only_for_roles: Utils.defaultPricingSellerRoles(),
        },
        opaque: {
            eshop_sort_weight: eshopWeight
        }
    };
    // Only seed iDIV when the instance has a local rate; seeding 0 makes
    // PricingForm show the field (idiv !== undefined) on tax.local = 0.
    if (Number(idiv) > 0)
        pricing.idiv = Number(idiv);
    return pricing;
}

// Reducer
export default function reducer(state = initialState, action) {
    switch (action.type) {
        case RESET_PRICINGLIST:
            return {
                ...state,
                pricinglist: {},
                isLoading: false,
                hasLoadingError: false,
            };
        case LOADING_PRICINGLISTS:
            return {
                ...state,
                isLoading: true,
                hasLoadingError: false
            };
        case LOADING_PRICINGLISTS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: false,
                pricinglistSuccessfullyDeleted: false,
                pricinglists: action.pricinglists
            };
        case LOADING_PRICINGLISTS_FAILURE:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: true,
                loadingErrorMessage: action.error.message,
                // Drop stale privileged rows (e.g. after spoof / lost readmany).
                pricinglists: [],
            };
        case LOADING_PRICINGLIST:
            return {
                ...state,
                isLoading: true,
                hasLoadingError: false
            };
        case LOADING_PRICINGLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: false,
                pricinglist: action.pricinglist
            };
        case LOADING_PRICINGLIST_FAILURE:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: true,
                loadingErrorMessage: action.error.message
            };
        case UPDATING_PRICINGLIST:
            return {
                ...state,
                isLoading: true,
                hasLoadingError: false
            };
        case UPDATING_PRICINGLIST_SUCCESS: {
            const updated = action.pricinglist;
            const updatedId = updated?._id;
            const pricinglists = !updatedId
                ? state.pricinglists
                : (state.pricinglists || []).map((pl) => (
                    pl?._id === updatedId ? updated : pl
                ));
            return {
                ...state,
                isLoading: false,
                hasLoadingError: false,
                pricinglist: updated,
                pricinglists,
            };
        }
        case UPDATING_PRICINGLIST_FAILURE:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: true,
                loadingErrorMessage: action.error.message
            };
        case DUPLICATING_PRICINGLIST:
            return {
                ...state,
                isLoading: true,
                hasLoadingError: false,
            };
        case DUPLICATING_PRICINGLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: false,
                duplicatedPricinglist: action.pricinglist
            };
        case DUPLICATING_PRICINGLIST_FAILURE:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: true,
                loadingErrorMessage: action.error.message
            };
        case START_CREATING_PRICINGLIST:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: false,
                pricinglistSuccessfullyCreated: false,
                // Ensure sane default pricinglist for creation
                pricinglist: {
                    "name": "",
                    "pricings": {},
                }
            };
        case CREATING_PRICINGLIST:
            return {
                ...state,
                isLoading: true,
                hasLoadingError: false
            };
        case CREATING_PRICINGLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: false,
                pricinglistSuccessfullyCreated: true,
                pricinglist: action.pricinglist
            };
        case CREATING_PRICINGLIST_FAILURE:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: true,
                pricinglistSuccessfullyCreated: false,
                loadingErrorMessage: action.error.message
            };
        case DELETING_PRICINGLIST:
            return {
                ...state,
                isLoading: true,
                hasLoadingError: false
            };
        case DELETING_PRICINGLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: false,
                pricinglistSuccessfullyDeleted: true,
                pricinglist: action.pricinglist
            };
        case DELETING_PRICINGLIST_FAILURE:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: true,
                pricinglistSuccessfullyDeleted: false,
                loadingErrorMessage: action.error.message
            };
        case ADDING_PRICING:
            return {
                ...state,
                pricinglist: {
                    ...state.pricinglist,
                    pricings: {
                        ...state.pricinglist.pricings,
                        [make_temporary_pricing_id()]: initialPricing(action.names, action.currency, action.vat, Object.keys(state.pricinglist.pricings).length + 1, action.idiv)
                    }
                }
            };
        case DUPLICATING_PRICING: {
            const source = state.pricinglist.pricings?.[action._id];
            if (!source)
                return state;
            const new_id = String(Date.now());
            const cloned = _.cloneDeep(source);
            if (!cloned.opaque)
                cloned.opaque = {};
            cloned.opaque.eshop_sort_weight = Object.keys(state.pricinglist.pricings).length + 1;
            return {
                ...state,
                pricinglist: {
                    ...state.pricinglist,
                    pricings: {
                        ...state.pricinglist.pricings,
                        [new_id]: cloned
                    }
                }
            };
        }
        case REMOVING_PRICING:
            const { [action._id]: toRemove, ...otherPricings } = state.pricinglist.pricings;
            return {
                ...state,
                pricinglist: {
                    ...state.pricinglist,
                    pricings: otherPricings
                }
            };
        case UPDATING_PRICINGLIST_ORDER:
            return {
                ...state,
                pricinglist: {
                    ...state.pricinglist,
                    pricings: action.pricings
                }
            };
        case UPDATING_PRICINGS_KEYS:
            const pricings = _.cloneDeep(state.pricinglist.pricings || {});
            if (pricings[action.values.newId])
                return { ...state }

            pricings[action.values.newId] = {
                ...pricings[action.values.oldId],
                ...(action.values.pricing_patch || {}),
            };
            delete pricings[action.values.oldId];
            return {
                ...state,
                pricinglist: {
                    ...state.pricinglist,
                    pricings
                }
            }
        default:
            return state;
    }
};

// Actions
function loadingPricinglists() { return { type: LOADING_PRICINGLISTS } }
function loadingPricinglistsSuccess(pricinglists) { return { type: LOADING_PRICINGLISTS_SUCCESS, pricinglists: pricinglists } }
function loadingPricinglistsFailure(err) { return { type: LOADING_PRICINGLISTS_FAILURE, error: err } }
export function loadPricinglists(_pricinglistname, _password) {
    return (dispatch) => {
        dispatch(loadingPricinglists());
        Pricinglists.list()
            .then(data => {
                const pricinglists = data.pricinglists;
                dispatch(loadingPricinglistsSuccess(pricinglists));
            })
            .catch(err => {
                console.log("err => ", err);
                dispatch(loadingPricinglistsFailure(err))
            });
    }
}

export function resetPricinglist() { return { type: RESET_PRICINGLIST } }
function loadingPricinglist() { return { type: LOADING_PRICINGLIST } }
function loadingPricinglistSuccess(pricinglist) { return { type: LOADING_PRICINGLIST_SUCCESS, pricinglist: pricinglist } }
function loadingPricinglistFailure(err) { return { type: LOADING_PRICINGLIST_FAILURE, error: err } }
export function loadPricinglist(pricinglistId) {
    return (dispatch) => {
        dispatch(loadingPricinglist());
        Pricinglists.get(pricinglistId)
            .then(data => {
                const pricinglist = data.pricinglist;
                dispatch(loadingPricinglistSuccess(pricinglist));
            })
            .catch(err => {
                dispatch(loadingPricinglistFailure(err))
            });
    }
}

function updatingPricinglist() { return { type: UPDATING_PRICINGLIST } }
function updatingPricinglistSuccess(pricinglist) { return { type: UPDATING_PRICINGLIST_SUCCESS, pricinglist: pricinglist } }
function updatingPricinglistFailure(err) { return { type: UPDATING_PRICINGLIST_FAILURE, error: err } }
export function updatePricinglist(pricinglist) {
    return (dispatch) => {
        dispatch(updatingPricinglist());
        Pricinglists.update(pricinglist)
            .then(data => {
                const pricinglist = data.pricinglist;
                dispatch(updatingPricinglistSuccess(pricinglist));
            })
            .catch(err => {
                dispatch(updatingPricinglistFailure(err))
            });
    }
}

function creatingPricinglist() { return { type: CREATING_PRICINGLIST } }
function creatingPricinglistSuccess(pricinglist) { return { type: CREATING_PRICINGLIST_SUCCESS, pricinglist: pricinglist } }
function creatingPricinglistFailure(err) { return { type: CREATING_PRICINGLIST_FAILURE, error: err } }
export function startCreatePricinglist() { return { type: START_CREATING_PRICINGLIST } }
export function createPricinglist(pricinglist) {
    return (dispatch) => {
        dispatch(creatingPricinglist());
        Pricinglists.create(pricinglist)
            .then(data => {
                const pricinglist = data.pricinglist;
                dispatch(creatingPricinglistSuccess(pricinglist));
                dispatch(loadingPricinglistSuccess(pricinglist));
            })
            .catch(err => {
                dispatch(creatingPricinglistFailure(err))
            });
    }
}

function deletingPricinglist() { return { type: DELETING_PRICINGLIST } }
function deletingPricinglistSuccess() { return { type: DELETING_PRICINGLIST_SUCCESS } }
function deletingPricinglistFailure(err) { return { type: DELETING_PRICINGLIST_FAILURE, error: err } }
export function deletePricinglist(pricinglistId) {
    return (dispatch) => {
        dispatch(deletingPricinglist());
        Pricinglists.delete(pricinglistId)
            .then(() => {
                dispatch(deletingPricinglistSuccess());
            })
            .catch(err => {
                dispatch(deletingPricinglistFailure(err))
            });
    }
}

function duplicatingPricinglist() { return { type: DUPLICATING_PRICINGLIST } }
function duplicatingPricinglistSuccess(pricinglist) { return { type: DUPLICATING_PRICINGLIST_SUCCESS, pricinglist: pricinglist } }
function duplicatingPricinglistFailure(err) { return { type: DUPLICATING_PRICINGLIST_FAILURE, error: err } }
export function duplicatePricinglist(pricinglist, options) {
    return (dispatch) => {
        dispatch(duplicatingPricinglist());
        Pricinglists.duplicate(pricinglist, options)
            .then(data => {
                const pricinglist = data.pricinglist;
                dispatch(duplicatingPricinglistSuccess(pricinglist));
            })
            .catch(err => {
                dispatch(duplicatingPricinglistFailure(err))
            });
    }
}

function addingPricing(names, currency) {
    const vat = Utils.tax()?.vat_tickets ?? 0;
    const idiv = Utils.tax()?.local ?? 0;
    return { type: ADDING_PRICING, names, currency, vat, idiv };
}
export function addPricing(names, currency) {
    return (dispatch, getState) => {
        dispatch(addingPricing(names, currency));
        // keepDirtyOnReinitialize does not inject new nested keys into the form.
        sync_pricinglist_form_pricings(dispatch, getState);
    }
}

function duplicatingPricing(_id) { return { type: DUPLICATING_PRICING, _id } }
export function duplicatePricing(_id) {
    return (dispatch, getState) => {
        dispatch(duplicatingPricing(_id));
        sync_pricinglist_form_pricings(dispatch, getState);
    }
}

function removingPricing(_id) { return { type: REMOVING_PRICING, _id } }
export function removePricing(_id) {
    return (dispatch, getState) => {
        dispatch(removingPricing(_id));
        sync_pricinglist_form_pricings(dispatch, getState);
    }
}

function updatingPricinglistePricings(pricings) { return { type: UPDATING_PRICINGLIST_ORDER, pricings } }
export function updatePricinglistPricings(pricings) {
    return (dispatch) => {
        dispatch(updatingPricinglistePricings(pricings));
    }
}

function updatingPricingsKeys(values) { return { type: UPDATING_PRICINGS_KEYS, values } }
export function updatePricingsKeys(values) {
    return (dispatch, getState) => {
        dispatch(updatingPricingsKeys(values));
        sync_pricinglist_form_pricings(dispatch, getState, {
            oldId: values?.oldId,
            newId: values?.newId,
        });
    }
}

export function setPricinglistAsDefault(pricinglist) {
    return (dispatch) => {
        dispatch(updatingPricinglist());
        Pricinglists.update({ ...pricinglist, is_default: true })
            .then(() => dispatch(loadPricinglists()))
            .catch(err => dispatch(updatingPricinglistFailure(err)));
    };
}

export function unsetPricinglistAsDefault(pricinglist) {
    return (dispatch) => {
        dispatch(updatingPricinglist());
        Pricinglists.update({ ...pricinglist, is_default: false })
            .then(() => dispatch(loadPricinglists()))
            .catch(err => dispatch(updatingPricinglistFailure(err)));
    };
}
